/* eslint-disable react/display-name */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactGA from 'react-ga';
import { TapThemeProvider } from '@tapresearch/ui/components';
// import * as Sentry from '@sentry/react';
import { ReactQueryDevtools } from 'react-query/devtools';
import store from '../redux';
import AssetContext from '../components/common/AssetContext';
import { BreadcrumbProvider } from '../components/common/Breadcrumb';
import { loadUser } from '../redux/actions/User';
import axios from 'axios';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
window.global = window;
window.React = global.React = React;
ReactGA.initialize('UA-44840552-1');
var queryClient = new QueryClient();
var INSIGHTS_ROOT_PATH = '/insights_platform';
var _obj;
// window.initSentry = (sentryDSN, releaseTimestamp, currentEnv) => {
//   console.log('starting sentry');
//   const ignoreErrors = [
//     /__show__deepen/,
//     /Access is denied/,
//     /anonymous function: captureException/,
//     /Blocked a frame with origin/,
//     /console is not defined/,
//     /event is not defined/,
//     /feedConf/,
//     /MyIPhoneApp_ModifyShowModalDialog/,
//     /vid_mate_check is not defined/,
//     /win\.document\.body/,
//     /window\._sharedData\.entry_data/,
//     /ztePageScrollModule/,
//   ];
//   Sentry.init({
//     dsn: sentryDSN,
//     environment: currentEnv,
//     release: releaseTimestamp,
//     ignoreErrors: ignoreErrors,
//     tracesSampleRate: currentEnv === 'development' ? 1.0 : 0.2,
//   });
// };
var PlatformType = Object.freeze((_obj = {}, _define_property(_obj, 0, 'iOS'), _define_property(_obj, 1, 'Android'), _define_property(_obj, 2, 'Javascript'), _define_property(_obj, 3, 'Iframe'), _define_property(_obj, 4, 'API'), _obj));
var RouterApp = function(_param) {
    var children = _param.children, currentUser = _param.currentUser, assets = _param.assets, props = _object_without_properties(_param, [
        "children",
        "currentUser",
        "assets"
    ]);
    // Load user into redux store
    var dispatch = useDispatch();
    var location = useLocation();
    useEffect(function() {
        dispatch(loadUser(currentUser));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentUser
    ]);
    // Add CSRF token to axios headers
    useEffect(function() {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('[name=csrf-token]').content;
    }, []);
    // Use google analytics to track page location changes
    useEffect(function() {
        var trailingSlash = location.pathname.charAt(location.pathname.length - 1) === '/' && !location.search;
        var pathName = trailingSlash ? location.pathname.slice(0, -1) : location.pathname;
        ReactGA.pageview(INSIGHTS_ROOT_PATH + pathName + location.search);
    }, [
        location
    ]);
    return /*#__PURE__*/ React.createElement(AssetContext.Provider, {
        value: _object_spread_props(_object_spread({}, assets, props), {
            PlatformType: PlatformType
        })
    }, /*#__PURE__*/ React.createElement(BreadcrumbProvider, null, children));
};
// function ErrorFallback() {
//   return (
//     <>
//       <p>An error has ocurred</p>
//       <a href="#" onClick={() => window.location.reload()}>
//         Click here to reload the page
//       </a>
//     </>
//   );
// }
export default function App(props) {
    return(// <Sentry.ErrorBoundary fallback={ErrorFallback}>
    /*#__PURE__*/ React.createElement(TapThemeProvider, null, /*#__PURE__*/ React.createElement(QueryClientProvider, {
        client: queryClient
    }, /*#__PURE__*/ React.createElement(Provider, {
        store: store
    }, /*#__PURE__*/ React.createElement(Router, {
        basename: INSIGHTS_ROOT_PATH
    }, /*#__PURE__*/ React.createElement(RouterApp, props))), /*#__PURE__*/ React.createElement(ReactQueryDevtools, {
        initialIsOpen: false
    }))));
}
